// The tour overlays the real app, so it has to clear MUI's own layers:
// drawer 1200, app bar 1201 (NavItem already pins its buttons to 1201),
// modal 1300, snackbar 1400, tooltip 1500.
export const TOUR_Z = {
  // Dim sits above the app shell but below anything the tour lifts.
  scrim: 1290,
  // The one live control (nav item or in-page button).
  target: 1295,
  // Tooltip and task banner sit above both.
  tip: 1305
} as const;
